module.exports = __webpack_public_path__ + "static/img/6.b96ca529.png";